// import APIs
import { deleteDutyLine } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';
import { DeleteDutyLineMutateParams } from './useDeleteDutyLine.types';

const useDeleteDutyLine = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: DeleteDutyLineMutateParams) => deleteDutyLine(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useDeleteDutyLine;
